import {
  ActionTypes as EntityActionTypes,
  entityActionChecker,
} from '../common/utils/entityActionCreator';
import {
  currentUserReducer as currentUser,
} from '../redux-modules/current-user';

const handlePreferenceGet = ({ payload, error }) => {
  if (error || !payload || !payload.resp || !payload.resp.ok) {
    return {};
  }
  return {
    contactPreferences: {
      emailContact: payload.json.isEmailAllowed,
      emailFormatType: payload.json.emailFormatType,
      phoneContact: payload.json.isPhoneAllowed,
    },
  };
};

const handleEventRegistrationDetailGet = (user = {}, action) => {
  const { payload: { json: { eventKey = '' } = {}, resp = {} } = {} } = action;
  const { settings = {} } = user || {};
  let registeredEvents = settings.registeredEvents || [];

  const registeredIndex = registeredEvents.indexOf(eventKey);

  // if user is registered and it's not in the list
  if (resp.ok && registeredIndex === -1) {
    // add
    registeredEvents = [...registeredEvents, eventKey];
  }

  // if user is not registered and it's in the list
  if (resp.status === 404 && registeredIndex > -1) {
    // remove
    registeredEvents = registeredEvents.filter(key => key !== eventKey);
  }

  return { registeredEvents };
};

export default (state, action) => {
  const user = currentUser(state, action);
  let newSettings = {};
  if (action.type === EntityActionTypes.GET && action.meta.namespace === 'preferences'
  ) {
    newSettings = {
      ...newSettings,
      ...handlePreferenceGet(action),
    };
  }
  if (
    (action.type === EntityActionTypes.GET ||
      action.type === EntityActionTypes.POST) &&
    action.meta.namespace === 'registration' &&
    (action.sequence && action.sequence.type === 'next')
  ) {
    newSettings = {
      ...newSettings,
      ...handleEventRegistrationDetailGet(user, action),
    };
  }

  if (
    action.type === EntityActionTypes.PUT &&
    action.meta.namespace === "preferences"
  ) {
    newSettings = {
      ...newSettings,
      ...handlePreferenceGet(action),
    };
  }

  return {
    ...user,
    settings: {
      ...user.settings,
      ...newSettings,
    },
  };
};



// WEBPACK FOOTER //
// ./src/reducers/accountUserReducer.js